import React from 'react';
import Text from '../../global/text/text';

export interface IBlueprintStringSettingItemProps {
    isRichText: boolean;
    textValue: string;
}

const BlueprintStringSettingItem = ({
    isRichText,
    textValue
}: IBlueprintStringSettingItemProps) => {
    return isRichText
        ? <div className='m-left-10px' dangerouslySetInnerHTML={{ __html: textValue }} />
        : <Text
            className='m-left-3px word-break'
            message={ textValue }
        />
    ;
};

export default BlueprintStringSettingItem;
